/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamname1Inputs */

const en_entity_teamname1 = /** @type {(inputs: Entity_Teamname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Name`)
};

const de_entity_teamname1 = /** @type {(inputs: Entity_Teamname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Team Name" |
*
* @param {Entity_Teamname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamname1 = /** @type {((inputs?: Entity_Teamname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamname1(inputs)
	return de_entity_teamname1(inputs)
});
export { entity_teamname1 as "entity_teamName" }